import React from 'react';
import styles from './Header.module.css';
import logo from "../../assets/images/logo-metropolis.png";
import arrow from "../../assets/svgs/arrow-icon.svg"

const ALLOWED_USERS = [
  "ahernandez", "marga", "atteneri",
  "irene", "javier", "jonathan",
  "leticia", "veronica", "marlon"
];

const MOSAICO_URL = "https://imetropolis.es/mosaico/"

const Header = ({ userName }) => {
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("TT");
    localStorage.removeItem("empleado");
  
    window.location.href = MOSAICO_URL;
  };

  const showGestion = ALLOWED_USERS.includes(userName);

  return (
    <header className={styles.header}>
      <nav className={styles.topbar}>
        <div className={styles.wrapperNav}>
          <a href = {`${MOSAICO_URL}Cortes.php`}>
            <img className={styles.logo} src={logo} alt="logo Metrópolis" />
          </a>
          <ul className={styles.mainNav}>
            <li className={styles.navItem}>
              <span className={styles.navLink}>Seguimiento</span>
              <ul className={styles.submenu}>
                <li><a href={`${MOSAICO_URL}Cortes.php?STipo_Prensa=1&STipo_Radio=1&STipo_Television=1&STipo_Digitales=1&I_SFecha=&F_SFecha=&Nuevo=1&POOKY_ACCION=ADD`}>Nueva publicación</a></li>
                <li><a href={`${MOSAICO_URL}Cortes.php?STipo_Prensa=1&STipo_Radio=1&STipo_Television=1&STipo_Digitales=1&I_SFecha=&F_SFecha=&Nuevo=1&POOKY_ACCION=ADD`} target='_blank' rel="noopener noreferrer">Nueva publicación (en nueva pestaña)</a></li>
                <li><a href="https://imetropolis.es/APE/dd.php" target='_blank' rel="noopener noreferrer">Planillo de seguimiento</a></li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Radios y TV</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href="https://brutos.imetropolis.es/brutos/?TS=bWFybG9ufENhbWluYW5kbzk4NjUh" target='_blank' rel="noopener noreferrer">Brutos</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://brutos.imetropolis.es/studio/?TS=bWFybG9ufENhbWluYW5kbzk4NjUh' target='_blank' rel="noopener noreferrer" >Subir archivo externo</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='/mosaico/grabar_parlamento/herramientas_grabar_parlamento.zip' download target='_blank' rel="noopener noreferrer">Parlamento</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/spreadsheets/d/1-M3oU6WIW8W3lF0hMtr98yKZ3O4vNFcxMs77eQYRIFU/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Radios online</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://drive.google.com/file/d/1dRnT5KuIyCsIEn5pNFpURIRMnGrOPWjE/view?usp=share_link' target='_blank' rel="noopener noreferrer">Tutorial del editor</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Periódicos</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} rel="noopener noreferrer"><i>Dosieres TurboJony</i></a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href={`${MOSAICO_URL}tools/trijeras/`} target='_blank' rel="noopener noreferrer">Editor de PDF</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://dbkaty.imetropolis.es/dbkaty' target='_blank' rel="noopener noreferrer">DbKaty</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://dbkaty.imetropolis.es/dbkaty/periodico.php' target='_blank' rel="noopener noreferrer">Hemeroteca</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/document/d/1xt4SMaD8NGigRwojL41U9yWR3wnvlMltsG-FEu9krcA/edit' target='_blank' rel="noopener noreferrer">Protocolo sobre dosieres</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Redes</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://tools.imetropolis.es/redes' target='_blank' rel="noopener noreferrer">Gestión noticias X</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href={`${MOSAICO_URL}Informes_Redes.php`} target='_blank' rel="noopener noreferrer">Informes X</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/document/d/1eIe0876hV0rmibcda44nzJodInvMDyLA2rFp9pZRcgk/edit' target='_blank' rel="noopener noreferrer">Protocolo informes X</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href={`${MOSAICO_URL}Informes_Presidencia.php`} target='_blank' rel="noopener noreferrer">Informes Presidencia</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/document/d/1zY9Tz1yTe0e5T2ms6xH-2Jl_wcjugHzgG3T7abZ3448/edit?tab=t.0#heading=h.chwaad1a0noe' target='_blank' rel="noopener noreferrer">Protocolo Presidencia</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/document/d/1Z_cRgvWbZ7CyqoTB_DumzPKK8BfAvYhm3wLQntNDlkY/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Redes de nuestros clientes</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/document/d/1Z_cRgvWbZ7CyqoTB_DumzPKK8BfAvYhm3wLQntNDlkY/edit?tab=t.0#heading=h.suy2iixhcy31' target='_blank' rel="noopener noreferrer">Redes clientes</a>
                    </li>
                  </ul>
                </li>
                
                <li><a href={`${MOSAICO_URL}Consumo/Distribucion.php`} target='_blank' rel="noopener noreferrer">Destacadas por cliente</a></li>
                <li><a href={`${MOSAICO_URL}Previsiones/`} target='_blank' rel="noopener noreferrer">Previsiones</a></li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Buscador de digitales</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://digitales.imetropolis.es/medios' target='_blank' rel="noopener noreferrer">Abrir buscador</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href={`${MOSAICO_URL}tools/ConvertirURL2PDF.php`} target='_blank' rel="noopener noreferrer">Convertir digital en PDF</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href={`${MOSAICO_URL}Documentacion/buscador_digitales.pdf`} target='_blank' rel="noopener noreferrer">Manual del buscador</a>
                    </li>
                  </ul>
                </li>

                <li><a href={`${MOSAICO_URL}notasprensa.php`} target='_blank' rel="noopener noreferrer">Buscador de notas enviadas</a></li>
                <li><a href='https://docs.google.com/a/metropoliscom.com/spreadsheets/d/1j09QnjV5Q3gVC2IpRfzDcSlJUvr--WHPMTTDdqwXILA/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Temas</a></li>
                <li><a href='https://docs.google.com/document/d/1lk2AKcyo2dK8_N--pN4tQe-lqpbjV1iXUdtTUQhNATE/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Protocolo inteligencia artificial</a></li>
                <li><a href='https://imetropolis.es/instrucciones/Manual_iMetropolis.pdf' target='_blank' rel="noopener noreferrer"> Biblia del seguimiento </a></li>

              </ul>
            </li>
            <li className={styles.navItem}>
              <span className={styles.navLink}>Gabinete de comunicación</span>
              <ul className={styles.submenu}>

              <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Notas de prensa</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://replicant.gabinetecom.es/replicant' target='_blank' rel="noopener noreferrer">Env&iacute;o de notas</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://replicant.gabinetecom.es/reportes/' target='_blank' rel="noopener noreferrer">Reporte de notas enviadas</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://replicant.gabinetecom.es/direcciones/' target='_blank' rel="noopener noreferrer">Gestión de destinatarios</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://drive.google.com/file/d/1rbIsaO-k5DsGNcbB2ebkwMbKG6PGwvXi/view?usp=sharing' target='_blank' rel="noopener noreferrer">Tutorial de la plataforma</a>
                    </li>
                  </ul>
                </li>

                <li><a href={`${MOSAICO_URL}tools/limpiar_correos.php`} target='_blank' rel="noopener noreferrer">Gesti&oacute;n correos duplicados</a></li>
                <li><a href={`${MOSAICO_URL}PFotografo.php`} target='_blank' rel="noopener noreferrer">Peticiones coberturas</a></li>
              </ul>
            </li>

            <li className={styles.navItem}>
              <span className={styles.navLink}>Equipo</span>
              <ul className={styles.submenu}>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Worky</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href="https://worky.gabinetecom.es" target='_blank'rel="noopener noreferrer">Worky</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href="https://docs.google.com/document/d/1upeYs2TfjLXwb1cB2hwJsNm0UyUfiDHrFJ3csikkv4s/edit?tab=t.0" target='_blank' rel="noopener noreferrer">Tutorial Worky</a>
                    </li>
                  </ul>
                </li>
                <li><a  href='https://worky.gabinetecom.es/ejecutivos/main.php' target='_blank' rel="noopener noreferrer">Proyectos</a></li>
                {/* <li><a  href='https://tools.imetropolis.es/adminmosaico/main.php' target='_blank' rel="noopener noreferrer">Personal</a></li> */}
                <li><a href='https://docs.google.com/spreadsheets/d/1dekadi9kFrkAUmPpk3yf41CzDtikbgWFSrOp1m1pcFM/edit#gid=0' target='_blank' rel="noopener noreferrer">Registro de material</a></li>
                <li><a href='https://docs.google.com/document/d/1l1uGbow3zaHhz5f6mjm0Zhkz1hUrpSBQHrpa1jG4V5M/' target='_blank' rel="noopener noreferrer">Teléfonos equipo</a></li>
                <li><a href={`${MOSAICO_URL}Vacaciones.php`} target='_blank' rel="noopener noreferrer">Vacaciones</a></li>
                <li><a href={`${MOSAICO_URL}images/Oficinas-Plano-2023_v02.png`} target='_blank' rel="noopener noreferrer">Planos oficinas</a></li>
              </ul>
            </li>
            <li className={styles.navItem}>
              <span className={styles.navLink}>Informes</span>
              <ul className={styles.submenu}>
                <li><a href='https://dbkaty.imetropolis.es/dbkaty' target='_blank' rel="noopener noreferrer">DbKaty</a></li>
                <li><a href='http://tools.imetropolis.es/informes-roi' target='_blank' rel="noopener noreferrer">Generador de gráficas ROI</a></li>
                <li><a href='https://docs.google.com/document/d/1yvDYcta2GLHKnlRWDWSi7Tv4-0LHlK_zzgvlahqUKdE/edit' target='_blank' rel="noopener noreferrer">Informes en marcha</a></li>
                <li><a href='https://tools.imetropolis.es/informes-redes/' target='_blank' rel="noopener noreferrer">Informe de redes sociales en tarjetas </a></li>
                <li><a href='https://imetropolis.es/porcentajes/' target='_blank' rel="noopener noreferrer">Calculadora de %</a></li>
                <li><a href='https://drive.google.com/file/d/1Fpl3N-E8PkaElzd8SAltTeq_JXb3dvzu/view?usp=sharing' target='_blank' rel="noopener noreferrer">Protocolo estad&iacute;sticas</a></li>
                <li><a href='https://docs.google.com/document/d/1tFhK8KwiBgctSRhwW29SVslQM2RgN7qeCymgyUXs_JM/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Protocolo informes</a></li>
              </ul>
            </li>
            <li className={styles.navItem}>
              <span className={styles.navLink}>Herramientas</span>
              <ul className={styles.submenu}>
              <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Audio y vídeo</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://docs.google.com/document/d/1FR7sc-0CHqD25fO1gtP4aqwD1Qcby4DTQn-lXDHxCNg/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Protocolo grabación de vídeos</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://chromewebstore.google.com/detail/video-downloader-professi/elicpjhcidhpjomhibiffojpinpmmpil' target='_blank' rel="noopener noreferrer">Extensión Chrome para descargar Audio / Vídeo</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://audiotrimmer.com/es/' target='_blank' rel="noopener noreferrer">Editor de audio online</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='http://online-video-cutter.com/es/' target='_blank' rel="noopener noreferrer">Editor de vídeo</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='http://www.descargavideos.tv/' target='_blank' rel="noopener noreferrer">Descargar TV nacional</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='http://es.fetchfile.net/all-video-services/' target='_blank' rel="noopener noreferrer">Descargar TV internacional</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://fdownloader.net/es' target='_blank' rel="noopener noreferrer">Descargar vídeo Facebook</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://dl84.dinaserver.com/yt-downloader/' target='_blank' rel="noopener noreferrer">Descargar vídeo Youtube</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href={`${MOSAICO_URL}Documentacion/Subtitulos.pdf`} target='_blank' rel="noopener noreferrer">Subtitular en Youtube</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Creatividades</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://docs.google.com/document/d/1K-p3-0lQm8dsvsWB6fHKmfDgztC_2mH3Hrm8pW8lIIM/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Protocolo creatividades</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://www.canva.com/design/DAFLpgvllrs/AMQSZhmhkcHKhULzpa44dA/watch?utm_content=DAFLpgvllrs&utm_campaign=designshare&utm_medium=link&utm_source=editor' target='_blank' rel="noopener noreferrer">Tutorial fondos Canva</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://www.canva.com/design/DAFpEQr_Hxo/mTDqwvBHVHTS4sDGTscJew/watch?utm_content=DAFpEQr_Hxo&utm_campaign=designshare&utm_medium=link&utm_source=editor' target='_blank' rel="noopener noreferrer">Tutorial mosaico Instagram</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://www.canva.com/design/DAFOEp0nu9c/FWiBdj5PBJ20PPJISQ8rCg/watch?utm_content=DAFOEp0nu9c&utm_campaign=designshare&utm_medium=link&utm_source=editor' target='_blank' rel="noopener noreferrer">Tutorial r&oacute;tulos Canva</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://www.canva.com/design/DAGFY3TzbVE/p9jtL-L2xNtI6GlPuk8YtQ/watch?utm_content=DAGFY3TzbVE&utm_campaign=designshare&utm_medium=link&utm_source=editor' target='_blank' rel="noopener noreferrer">Tutorial cambiar color logos</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Documentos</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://www.ilovepdf.com/es' target='_blank' rel="noopener noreferrer">Editor de PDF</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://yumpudownload.com/' target='_blank' rel="noopener noreferrer">Descargar documentos p&uacute;blicos</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Texto</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://www.sinonimosonline.com/' target='_blank' rel="noopener noreferrer">Diccionario de sin&oacute;nimos</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='http://utilidades.gatovolador.net/issuu/' target='_blank' rel="noopener noreferrer">Descargar libros</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Web y mail</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://drive.google.com/drive/folders/1r5z8Dnx0eUba87uBW2oMIew_ItsKvgS6?usp=drive_link' target='_blank' rel="noopener noreferrer">Subir noticias Wordpress</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://drive.google.com/drive/folders/1r5z8Dnx0eUba87uBW2oMIew_ItsKvgS6?usp=drive_link' target='_blank' rel="noopener noreferrer">Mailjet Canarias Sin Deuda</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://docs.google.com/document/d/19p4HMgH13cdNR4jTS0hhnd7fXD6JfmhYHo8pLdDS0vA/edit?usp=sharing' target='_blank' rel="noopener noreferrer">Mailjet SJD</a>
                    </li>
                  </ul>
                </li>

                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>Otros</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                    <a className={styles.navLink} href='https://webmii.com/' target='_blank' rel="noopener noreferrer">Buscador de personas</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://chrome.google.com/webstore/detail/print-friendly-pdf/ohlencieiipommannpdfcmfdpjjmeolj?hl=es' target='_blank' rel="noopener noreferrer">Convertir WEB en PDF</a>
                    </li>
                    <li className={styles.navItem}>
                      <a className={styles.navLink} href='https://chrome.google.com/webstore/detail/aix-downloaderpicturevide/ggcihihkaidbkkolahhliaaepdjhngli/related?hl=es' target='_blank' rel="noopener noreferrer">Descargar archivos</a>
                    </li>
                  </ul>
                </li>

              </ul>
            </li>

            {showGestion && (
              <li className={styles.navItem}>
              <span className={styles.navLink}>Gestión</span>
              <ul className={styles.submenu}>
                <li><a  href='https://tools.imetropolis.es/adminmosaico/main.php' target='_blank' rel="noopener noreferrer">Personal</a></li>
                <li className={styles.navItem}>
                  <div className={styles.navLinkWithIcon}>
                    <span>iMetrópolis</span>
                    <img className={styles.icon} src={arrow} alt="Icono" />
                  </div>
                  <ul className={styles.secondarySubmenu}>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}GGC/`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Clientes
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href="https://tools.imetropolis.es/alertas/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Alertas
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}temas/Temas.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Temas
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Consumo
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/vip.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        VIP
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/Huerfanas.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Huérfanas
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/consumo.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Por clientes
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/quincena.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Tendencias
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/informe.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Accesos
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/politica-portadas.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Política y Portadas
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href={`${MOSAICO_URL}Consumo/actividad-clientes.php`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Usuarios activos por cliente
                      </a>
                    </li>
                    <li className={styles.navItem}>
                      <a
                        className={styles.navLink}
                        href="https://tools.imetropolis.es/superle"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Gestión de Informes ROI
                      </a>
                    </li>
                  </ul>
                </li>
                <li className={styles.navItem}>
                  <a
                    className={styles.navLink}
                    href={`${MOSAICO_URL}descriptores/Descriptores.php`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descriptores
                  </a>
                </li>
                <li className={styles.navItem}>
                  <a
                    className={styles.navLink}
                    href={`${MOSAICO_URL}Entregas.php`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Horas entrega dosieres
                  </a>
                </li>
                <li className={styles.navItem}>
                  <a
                    className={styles.navLink}
                    href={`${MOSAICO_URL}Consumo/Noticias.php`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Número de reseñas por día
                  </a>
                </li>
                <li className={styles.navItem}>
                  <a
                    className={styles.navLink}
                    href={`${MOSAICO_URL}leti/`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Productividad
                  </a>
                </li>
                <li className={styles.navItem}>
                  <a
                    className={styles.navLink}
                    href="https://tools.imetropolis.es/gMetropolis/propuestas/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Propuestas
                  </a>
                </li>
              </ul>
            </li>
          )}

          </ul>
        </div>
        <a className={styles.navLink} href={`${MOSAICO_URL}`} onClick={handleLogout} target='_self' rel="noopener noreferrer">Salir</a>
      </nav>
    </header>
  );
};

export default Header;
